import React from 'react';
import { GraduationCap, Users, Shield } from 'lucide-react';
import '../styles.css';

const WhoWeServeSection: React.FC = () => {
  return (
    <section className='serve-section'>
      <div className='serve-dot-pattern' />

      <div className='serve-container'>
        <div className='serve-header'>
          <h2>Who Athena Serves</h2>
        </div>

        <div className='serve-grid'>
          {/* Students & Researchers Card */}
          <div className='serve-card'>
            <div className='serve-card-icon'>
              <div className='serve-card-icon-inner yellow-bg'>
                <GraduationCap strokeWidth={2.5} />
              </div>
              <div className='serve-card-accent yellow' />
            </div>

            <h3>Students & Researchers</h3>
            <ul>
              <li>
                <span>•</span>
                <span>Discover relevant needs</span>
              </li>
              <li>
                <span>•</span>
                <span>Connect across institutional boundaries</span>
              </li>
              <li>
                <span>•</span>
                <span>Deliver critical innovations</span>
              </li>
            </ul>
          </div>

          {/* Joint Forces & Industry Card */}
          <div className='serve-card'>
            <div className='serve-card-icon'>
              <div className='serve-card-icon-inner translucent-bg'>
                <Users strokeWidth={2.5} />
              </div>
              <div className='serve-card-accent white' />
            </div>

            <h3>Joint Forces & Industry</h3>
            <ul>
              <li>
                <span>•</span>
                <span>
                  Leverage, integrate and collaborate with NPS resources to
                  accelerate ability to innovate
                </span>
              </li>
              <li>
                <span>•</span>
                <span>Coordinate research effortlessly</span>
              </li>
            </ul>
          </div>

          {/* Warfighters Card */}
          <div className='serve-card'>
            <div className='serve-card-icon'>
              <div className='serve-card-icon-inner yellow-tint-bg'>
                <Shield strokeWidth={2.5} />
              </div>
              <div className='serve-card-accent yellow' />
            </div>

            <h3>Warfighters</h3>
            <ul>
              <li>
                <span>•</span>
                <span>
                  Champion needs to help researchers and partners understand
                  requirements, priorities, and opportunities for innovation
                </span>
              </li>
              <li>
                <span>•</span>
                <span>
                  Influence research agendas and connect challenges to experts
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeServeSection;
